import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/wishlist-vs-cart")({
  component: lazyRouteComponent(() => import("./-pages/admin.wishlist-vs-cart")),
  head: () => ({
    meta: [
      { title: "Wishlist vs Cart · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
